module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/ht30.a4cdbd85.png";